import { client, getUrl } from "utils";

export const getTrackBaseRequest = (filterParams) => client.post("scrape-tasks/search", filterParams);

export const getTrackRequest = ({ initialTrackId, trackID, searchParams }) => {
    const newSearchParams = { ...searchParams };
    newSearchParams.limit = 1;
    newSearchParams.track_id = trackID;
    newSearchParams.initial_track_id = initialTrackId;

    return client.post(`scrape-tasks/search`, newSearchParams);
};

export const getTracksCountRequest = ({ parentTrackId, initialTrackId, searchParams }) => {
    const newSearchParams = { ...searchParams };
    newSearchParams.limit = 0;
    newSearchParams.parent_track_id = parentTrackId;
    newSearchParams.initial_track_id = initialTrackId;

    return client.post(`scrape-tasks/search/count`, newSearchParams);
};

export const getChildrenTrackRequest = (searchParams) => {
    return client.post(`scrape-tasks/search`, searchParams);
};

export const getTemplateChildrenRequest = (searchParams) => {
    return client.post(`scrape-tasks/search/count`, searchParams).then(
        data => ({
            statusType: searchParams.status_type_code,
            count: data.count
        })
    );
};

export const getHttpResponseRequest = ({ initialTrackId, filterParams }) => client.get(getUrl(`scrape-task/${initialTrackId}/http-response`, filterParams));

export const getHttpRequestRequest = ({ initialTrackId, filterParams }) => client.get(getUrl(`scrape-task/${initialTrackId}/http-request`, filterParams));

export const getMetadataRequest = ({ initialTrackId, filterParams }) => client.get(getUrl(`scrape-task/${initialTrackId}/metadata`, filterParams));

export const getResultObjectsRequest = ({ initialTrackId, filterParams }) => client.get(getUrl(`scrape-task/${initialTrackId}/result-objects`, filterParams));

export const exportTrackResultObjectsRequest = ({ track_id, initial_track_id, storage_type_code }) => client.get(
    `scrape-task/${track_id}/result-object/export?initial_track_id=${initial_track_id}&storage_type_code=${storage_type_code}`
);

export const getScrapeAttemptsRequest = ({ initialTrackId, filterParams }) => client.get(getUrl(`scrape-task/${initialTrackId}/scrape-attempts`, filterParams));

export const stopTrackRequest = (trackId) => client.get(`scrape-task/${trackId}/stop`);

export const getObjectStructureRequest = (receiverCode) => client.get(`object-structures?receiver_code=${receiverCode}`);

export const getStatusHistoryRequest = (trackId) => client.get(`scrape-task/${trackId}/status-history`);

export const pidProcessRequest = (pid) => client.get(`process/${pid}`);
